export default "__VITE_ASSET__69a576c8__"